import { render, staticRenderFns } from "./ChangePhone.vue?vue&type=template&id=266f6f00&scoped=true&"
import script from "./ChangePhone.vue?vue&type=script&lang=js&"
export * from "./ChangePhone.vue?vue&type=script&lang=js&"
import style0 from "./ChangePhone.vue?vue&type=style&index=0&id=266f6f00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266f6f00",
  null
  
)

export default component.exports